import { FC } from 'react';

import { ButtonProps } from '@/shared/uikit/Button';

import { ButtonWithLoaderIw } from './ButtonWithLoaderIw';

export const ButtonIw: FC<ButtonProps> = ({ children, style, ...props }) => {
  const btnStyle = {
    ...style,
    height: '44px',
  };

  return (
    <ButtonWithLoaderIw style={btnStyle} {...props}>
      {children}
    </ButtonWithLoaderIw>
  );
};
